import { useMemo } from 'react'
import { Box, Breadcrumbs, Typography, Stack, Button, Chip } from '@mui/material'
import { Download } from '@mui/icons-material'
import { DataGrid, type GridColDef } from '@mui/x-data-grid'
import { useMutation, useQuery } from '@tanstack/react-query'
import { listAssetExits, getAssetExitsExportUrl, type AssetExit } from '../../api/active'

export default function IesiriActivePage() {
  const { data, isLoading } = useQuery({ queryKey: ['active', 'iesiri'], queryFn: listAssetExits })

  const exportMutation = useMutation({
    mutationFn: getAssetExitsExportUrl,
    onSuccess: (blob) => window.open(URL.createObjectURL(blob), '_blank'),
  })

  const columns = useMemo<GridColDef<AssetExit>[]>(() => [
    { field: 'inventoryNumber', headerName: 'Nr. inventar', width: 150, renderCell: (p) => <code>{p.row.inventoryNumber}</code> },
    { field: 'assetName', headerName: 'Denumire', flex: 1, minWidth: 200 },
    {
      field: 'exitType', headerName: 'Tip ieșire', width: 130, sortable: false,
      renderCell: (p) => <Chip size="small" label={p.row.exitType === 'Vanzare' ? 'Vânzare' : 'Casare'} color={p.row.exitType === 'Vanzare' ? 'secondary' : 'error'} variant="outlined" />,
    },
    { field: 'date', headerName: 'Dată', width: 110 },
    { field: 'counterpartyOrReason', headerName: 'Cumpărător / motiv', width: 200 },
    { field: 'amount', headerName: 'Preț vânzare', width: 130, type: 'number', renderCell: (p) => p.row.amount?.toFixed(2).replace('.', ',') ?? '—' },
    { field: 'gainLoss', headerName: 'Câștig/pierdere', width: 140, type: 'number', renderCell: (p) => p.row.gainLoss?.toFixed(2).replace('.', ',') ?? '—' },
    { field: 'invoiceNumber', headerName: 'Nr. factură', width: 140, renderCell: (p) => p.row.invoiceNumber ?? '—' },
  ], [])

  return (
    <Stack spacing={2}>
      <Breadcrumbs separator="/" sx={{ fontSize: 12.5 }}>
        <Typography variant="inherit" color="text.secondary">Active fixe</Typography>
        <Typography variant="inherit" color="text.primary">Ieșiri</Typography>
      </Breadcrumbs>
      <Typography variant="h2">Ieșiri de active fixe</Typography>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button variant="outlined" startIcon={<Download />} disabled={exportMutation.isPending} onClick={() => exportMutation.mutate()}>
          Export SAGA
        </Button>
      </Box>
      <Box sx={{ height: 600, bgcolor: 'background.paper', borderRadius: 1.5 }}>
        <DataGrid rows={data ?? []} columns={columns} getRowId={(r) => `${r.assetId}-${r.exitType}-${r.date}`} loading={isLoading}
          density="comfortable" disableRowSelectionOnClick
          initialState={{ pagination: { paginationModel: { pageSize: 25 } } }} pageSizeOptions={[25, 50]} />
      </Box>
    </Stack>
  )
}
